import {DisplayAdVo} from '../../common/shared/api/gateway/DisplayAdVo.interface';
import {DisplayAdGroup, GroupType} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createDisplayAdItem} from './DisplayAdItem';

export function createGroupWithDisplayAdVo(
  display_ad: DisplayAdVo,
  sectionId: string
): DisplayAdGroup {
  const displayAd = createDisplayAd(display_ad);
  const id = `${sectionId}-da-${display_ad.section_uid}`;
  return {
    id,
    type: GroupType.DisplayAd,
    items: [createDisplayAdItem(displayAd)],
  };
}
